/**
 * @Author xuchen
 * @Date 2020-01-20 09:15:40
 * @Desc 企业视频巡查
 */
import http from './instance'

export default {
  /**
   * @author xuchen
   * @date 2020-03-10 16:08:42
   * @desc 获取企业列表
   */
  getEnterpriseList(payload) {
    return http.post('/inspection/enterprise/page', payload)
  },

  /**
   * @author xuchen
   * @date 2020-03-17 10:18:59
   * @desc 获取企业详情
   */
  getEnterpriseInfo(payload) {
    return http.post('/inspection/enterprise/detail', payload)
  },

  /**
   * @author xuchen
   * @date 2020-03-17 10:27:01
   * @desc 获取监控点
   */
  getMonitorPoints(payload) {
    return http.post('/inspection/enterprise/monitor', payload)
  },

  /**
   * @author xuchen
   * @date 2020-03-17 20:02:26
   * @desc 获取监控视频的播放参数
   */
  getVideoParams(payload) {
    return http.post('/inspection/video/param', payload)
  },

  /**
   * @author chenguanbin
   * @date 2020-04-15 18:34:36
   * @desc 更新视频封面
   */
  updateCover(payload) {
    return http.post('/inspection/cover', payload, {
      noMsg: true
    })
  },

  /**
   * @Author maogangfeng
   * @Date 2020-03-20 16:47:06
   * @Desc 获取视频巡查页面企业列表搜索条件
   */
  getEnterpriseConditions(payload) {
    return http.post('/inspection/search', payload)
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-20 18:47:58
   * @Desc 获取项目所在的区域列表
   */
  queryDutyRegion(payload) {
    return http.post('/inspection/queryAuthRegions', payload)
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-23 18:49:29
   * @Desc 视频巡查页面预警上报
   */
  alarmPush(payload) {
    return http.post('/inspection/alter/upload', payload)
  },
  uploadCapture(payload) {
    return http.post('/inspection/image', payload)
  }
}
